export default "__VITE_ASSET__df8452ce__"